import React from 'react';
import styled from 'styled-components';

import Title1 from '@joinforma/ui/components/Title1';

import type { Product } from '../types';
import { SIZE_OPTIONS, StyleOptions } from './consts';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Detail = styled.div`
  border-right: 1px solid ${({ theme }) => theme.colors.text.secondary};
  padding: 0 4px;

  &:first-of-type {
    padding: 0 4px 0 0;
  }

  &:last-of-type {
    border-right: none;
  }
`;

const ProductDetails = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  font-size: ${({ size = SIZE_OPTIONS.LARGE }: { size?: string }): string =>
    StyleOptions[size].textSize};
  flex: 1 1 auto;
  flex-direction: row;
  text-transform: uppercase;
`;

const ProductTitle = styled(Title1)`
  color : ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ size = SIZE_OPTIONS.LARGE }: { size?: string }): string =>
    StyleOptions[size].headlineSize};
}`;

const VendorTitle = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 14px;
  line-height: 21px;
`;

const Details = ({ product, size }: { product: Product; size: string }) => {
  const {
    is_shipping_required: isShippingRequiredInfo,
    product_name: productName,
    product_title: productTitle,
    term,
    variations,
    vendor_title: vendorTitle,
  } = product;

  const isSubscription = term === 'monthly';
  const isShippingRequired = !isSubscription && isShippingRequiredInfo;

  const title = productName ? productName : productTitle;

  /**
   * The name of the property inside variations.options varies.
   * This gets the name of the property containing the label and variations list.
   */
  const variationProp =
    variations?.options && Object.keys(variations.options)[0];
  const variationText = variationProp
    ? variations?.options[variationProp].values.length > 1 &&
      `${variations?.options[variationProp].values.length} ${variations?.options[variationProp].label}`
    : variations?.products.length &&
      variations.products.length > 1 &&
      `${variations?.products.length} Plans`;

  return (
    <Container>
      <VendorTitle>{vendorTitle}</VendorTitle>
      <ProductTitle size={size}>{title}</ProductTitle>
      <ProductDetails size={size}>
        {isShippingRequired && <Detail>Free Shipping</Detail>}
        {variationText && <Detail>{variationText}</Detail>}
        {isSubscription && <Detail>Subscription</Detail>}
      </ProductDetails>
    </Container>
  );
};

export default Details;
